import * as React from 'react';
import GenderComponent from "./forms/GenderComponent";
import GiftFormValues, {Relationship} from "./GiftFormValues";
import AgeForm from "./forms/AgeComponent";
import Button from "@mui/material/Button";
import {SubmitFunction} from "./GiftPage";
import {SelectChangeEvent} from "@mui/material";
import Grid from '@mui/material/Unstable_Grid2';
import {FORM_CLICK_FIELD, useRecommendedAnalyticsEventTracker} from "./GoogleAnalytics";
import RelationshipComponent from "./forms/RelationshipComponent";
import OccasionComponent from "./forms/OccasionComponent";
import HobbiesComponent from "./forms/HobbiesComponent";
import {useSearchParams} from "react-router-dom";


interface GiftFormProps {
    onSubmit: SubmitFunction,
    defaults: GiftFormValues
}


const GiftForm = (props: GiftFormProps) => {

    const recommendedEventTracker = useRecommendedAnalyticsEventTracker();
    const [urlParams] = useSearchParams();
    console.log("urlParams", urlParams);

    const [giftForm, setGiftForm] = React.useState<GiftFormValues>(
        {...props.defaults},
    );

    const updateFormValue = (value: Object) => {
        let keys = Object.keys(value);
        if (keys.length > 0) {
            recommendedEventTracker(FORM_CLICK_FIELD, {
                "field_name": keys[0],
                "field_value": value[keys[0] as keyof typeof value]
            })
        } else {
            recommendedEventTracker(FORM_CLICK_FIELD, {
                "field_name": keys[0],
                "field_value": "unkown"
            })
        }
        let tmpValues = {...giftForm, ...value};
        setGiftForm(tmpValues);
    }

    const onSubmit = () => {
        console.log("submit", giftForm)
        props.onSubmit(giftForm)
    }

    const handleChange = (event: SelectChangeEvent<string[]>) => {
        const {
            target: {value},
        } = event;
        updateFormValue(
            {hobbies: typeof value === 'string' ? value.split(',') : value}
        );
    };

    return (
        <Grid container rowSpacing={5}>

            <Grid xs={12}>
                <GenderComponent updateValue={(gender) => {
                    updateFormValue({gender: gender})
                }}
                                 gender={giftForm.gender}/>
            </Grid>

            <Grid xs={12}>
                <AgeForm updateValue={(age) => {
                    updateFormValue({age: age})
                }} age={giftForm.age}/>
            </Grid>

            <Grid xs={12}>
                <RelationshipComponent updateValue={(relationship: string) => {
                    updateFormValue({relationship: relationship as keyof Relationship});
                }} relationship={giftForm.relationship}/>
            </Grid>
            <Grid xs={12}>
                <OccasionComponent updateValue={(occasion: string) => {
                    updateFormValue({occasion: occasion});
                }} occasion={giftForm.occasion}/>
            </Grid>
            <Grid xs={12}>
                <HobbiesComponent updateValue={(hobbies: string[]) => {
                    updateFormValue(
                        {hobbies: hobbies}
                    );
                }} hobbies={giftForm.hobbies}/>
            </Grid>
            <Grid xs={12}>
                <Button variant="contained" onClick={onSubmit}>Zeig mir die Ideen!</Button>
            </Grid>
        </Grid>
    );
}

export default GiftForm;